/**
 * Paleta do SummernoteEditor (Text Color)
 * Chave = cor da paleta; valor = cor de contraste ideal para tema escuro
 */
export const summernotePaletteContrastDark = {
  '#000000': '#FFFFFF',
  '#424242': '#E3E3E3',
  '#636363': '#C6C6C6',
  '#9C9C94': '#9C9C94',
  '#CEC6CE': '#CEC6CE',
  '#EFEFEF': '#EFEFEF',
  '#F7F7F7': '#F7F7F7',
  '#FFFFFF': '#FFFFFF',
  '#FF0000': '#FF0000',
  '#FF9C00': '#FF9C00',
  '#FFFF00': '#FFFF00',
  '#00FF00': '#00FF00',
  '#00FFFF': '#00FFFF',
  '#0000FF': '#0000FF',
  '#9C00FF': '#9C00FF',
  '#FF00FF': '#FF00FF',
  '#F7C6CE': '#F7C6CE',
  '#FFE7CE': '#FFE7CE',
  '#FFEFC6': '#FFEFC6',
  '#D6EFD6': '#D6EFD6',
  '#CEDEE7': '#CEDEE7',
  '#CEE7F7': '#CEE7F7',
  '#D6D6E7': '#D6D6E7',
  '#E7D6DE': '#E7D6DE',
  '#E79C9C': '#E79C9C',
  '#FFC69C': '#FFC69C',
  '#FFE79C': '#FFE79C',
  '#B5D6A5': '#B5D6A5',
  '#A5C6CE': '#A5C6CE',
  '#9CC6EF': '#9CC6EF',
  '#B5A5D6': '#B5A5D6',
  '#D6A5BD': '#D6A5BD',
  '#E76363': '#E76363',
  '#F7AD6B': '#F7AD6B',
  '#FFD663': '#FFD663',
  '#94BD7B': '#94BD7B',
  '#73A5AD': '#73A5AD',
  '#6BADDE': '#6BADDE',
  '#8C7BC6': '#8C7BC6',
  '#C67BA5': '#C67BA5',
  '#CE0000': '#CE0000',
  '#E79439': '#E79439',
  '#EFC631': '#EFC631',
  '#6BA54A': '#6BA54A',
  '#4A7B8C': '#4A7B8C',
  '#3984C6': '#3984C6',
  '#634AA5': '#634AA5',
  '#A54A7B': '#A54A7B',
  '#9C0000': '#9C0000',
  '#B56308': '#B56308',
  '#BD9400': '#BD9400',
  '#397B21': '#397B21',
  '#104A5A': '#29788E',
  '#085294': '#2172C1',
  '#311873': '#311873',
  '#731842': '#9E3464',
  '#630000': '#AE2323',
  '#7B3900': '#B56722',
  '#846300': '#BF941B',
  '#295218': '#56973B',
  '#083139': '#1F626E',
  '#003163': '#0E5295',
  '#21104A': '#472993',
  '#4A1031': '#952965',
};
